//@flow

import { compose, defaultProps } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'common/components/core/router';
import { getClientDimensionsMapping } from 'common/redux/selectors/clientSelector';
import UnitConversionHelper from 'common/helpers/UnitConversionHelper';
import Units from 'common/enums/UnitEnum';

type Props = {
    value: number,
    sourceUnit?: Object,
    unit?: string,
    totalValue?: number,
    conversionScale?: string,
    roundOff?: boolean,
    padLeft?: boolean,
    decimals?: number,
    pluralizeUnit?: boolean,
    showUnitAbbr?: boolean,
    theme: Object
};

export const mapStateToProps = (state: Object, ownProps: Props) => {
    const dimensionsMapping = getClientDimensionsMapping(state, ownProps);
    const UnitConverter = new UnitConversionHelper({ dimensionsMapping });
    const { unit, value, totalValue } = UnitConverter.convertValue(ownProps);

    return {
        ...ownProps,
        unit,
        value,
        totalValue,
        pluralizeUnit: false
    };
};

export const StatisticUnitConnectHOC = compose(
    withRouter,
    defaultProps({
        roundOff: true,
        decimals: 0,
        padLeft: true,
        conversionScale: Units.conversionScale.Factor
    }),
    connect(mapStateToProps)
);

export default StatisticUnitConnectHOC;
